import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { colors, sizes, font, positions } from "../../../enums";
import classnames from 'classnames';
import { whitelistStyles } from "../../core/hoc";
import Button from "../../core/button";
var SaveButtons = createComponent({
  displayName: 'SaveButtons',
  propTypes: {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onApply: PropTypes.func,
    isFluid: PropTypes.bool,
    isDisabled: PropTypes.bool,
    tooltips: PropTypes.shape({
      save: PropTypes.string,
      cancel: PropTypes.string,
      apply: PropTypes.string
    }),
    tooltipPositions: PropTypes.shape({
      save: PropTypes.oneOf(positions.ALL),
      cancel: PropTypes.oneOf(positions.ALL),
      apply: PropTypes.oneOf(positions.ALL)
    }),
    primaryColor: PropTypes.oneOf(_.without(colors.CORE, colors.ERROR, colors.WARNING)),
    secondaryColor: PropTypes.oneOf(_.without(colors.CORE, colors.ERROR, colors.WARNING)),
    saveAnimationActions: PropTypes.oneOfType([PropTypes.shape(actionShape), PropTypes.arrayOf(PropTypes.shape(actionShape))]),
    applyAnimationActions: PropTypes.oneOfType([PropTypes.shape(actionShape), PropTypes.arrayOf(PropTypes.shape(actionShape))])
  },
  defaultProps: {
    onApply: null,
    isFluid: false,
    isDisabled: false,
    tooltips: {
      save: '',
      cancel: '',
      apply: ''
    },
    tooltipPositions: {
      save: positions.TOP,
      cancel: positions.TOP,
      apply: positions.TOP
    },
    primaryColor: colors.BASE,
    secondaryColor: colors.BASE,
    saveAnimationActions: undefined,
    applyAnimationActions: undefined
  },
  render: function render(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames('ck-save-buttons', {
        'has-apply': props.onApply !== null,
        fluid: props.isFluid
      }),
      style: props.style
    }, /*#__PURE__*/React.createElement(Button.Group, {
      size: sizes.X3,
      isFluid: props.isFluid
    }, /*#__PURE__*/React.createElement(Button.Secondary, {
      color: props.secondaryColor,
      text: "CANCEL",
      tooltip: props.tooltips.cancel,
      tooltipPosition: props.tooltipPositions.cancel,
      font: {
        family: font.families.CUSTOM,
        weight: font.weights.MEDIUM
      },
      onClick: props.onCancel
    }), props.onApply !== null ? props.applyAnimationActions ? /*#__PURE__*/React.createElement(Button.WithAnimation, {
      actions: props.applyAnimationActions
    }, /*#__PURE__*/React.createElement(ApplyButton, props)) : /*#__PURE__*/React.createElement(ApplyButton, props) : null, props.saveAnimationActions ? /*#__PURE__*/React.createElement(Button.WithAnimation, {
      actions: props.saveAnimationActions
    }, /*#__PURE__*/React.createElement(SaveButton, props)) : /*#__PURE__*/React.createElement(SaveButton, props)));
  }
});

function SaveButton(_ref) {
  var primaryColor = _ref.primaryColor,
      onSave = _ref.onSave,
      isDisabled = _ref.isDisabled,
      tooltips = _ref.tooltips,
      tooltipPositions = _ref.tooltipPositions,
      buttonState = _ref.buttonState;
  return /*#__PURE__*/React.createElement(Button.Primary, {
    color: primaryColor,
    text: "SAVE",
    onClick: onSave,
    isDisabled: isDisabled,
    tooltip: tooltips.save,
    tooltipPosition: tooltipPositions.save,
    buttonState: buttonState
  });
}

function ApplyButton(_ref2) {
  var secondaryColor = _ref2.secondaryColor,
      onApply = _ref2.onApply,
      isDisabled = _ref2.isDisabled,
      tooltips = _ref2.tooltips,
      tooltipPositions = _ref2.tooltipPositions,
      buttonState = _ref2.buttonState;
  return /*#__PURE__*/React.createElement(Button.Secondary, {
    color: secondaryColor,
    text: "APPLY",
    tooltip: tooltips.apply,
    tooltipPosition: tooltipPositions.apply,
    font: {
      family: font.families.CUSTOM,
      weight: font.weights.MEDIUM
    },
    onClick: onApply,
    isDisabled: isDisabled,
    buttonState: buttonState
  });
}

var actionShape = {
  start: PropTypes.func,
  success: PropTypes.func,
  failure: PropTypes.func
};
export default whitelistStyles()(SaveButtons);
//# sourceMappingURL=index.js.map